/** @format */
import Cookie from 'js-cookie';
import { useEffect, useState } from 'react';

export const RECENTLY_VIEWED_PRODUCTS_KEY = 'RECENTLY_VIEWED_PRODUCTS';

const getRecentlyViewedProducts = (): number[] => {
    const recentlyViewedProducts = window.localStorage.getItem(
        RECENTLY_VIEWED_PRODUCTS_KEY
    );

    return recentlyViewedProducts ? JSON.parse(recentlyViewedProducts) : [];
};

const setRecentlyViewedProducts = (recentlyViewedProducts: number[]) =>
    window.localStorage.setItem(
        RECENTLY_VIEWED_PRODUCTS_KEY,
        JSON.stringify(recentlyViewedProducts)
    );

const addRecentlyViewedProduct = (productId: number) => {
    const recentlyViewedProducts = getRecentlyViewedProducts();

    if (recentlyViewedProducts.includes(productId)) return;

    setRecentlyViewedProducts([...recentlyViewedProducts, productId]);
};

export const useRecentlyViewedProducts = () => {
    const [hasMounted, setHasMounted] = useState(false);

    const isProductRecentlyViewed = (productId: number) =>
        hasMounted && getRecentlyViewedProducts().includes(productId);

    /**
     * Store a cookie to determine if the browser session is the same
     * The cookie will be removed when the browser is closed
     */
    useEffect(() => {
        if (typeof window === 'undefined') return;

        const isSameBrowserSession = Cookie.get(RECENTLY_VIEWED_PRODUCTS_KEY);

        if (!isSameBrowserSession) {
            setRecentlyViewedProducts([]);
            Cookie.set(RECENTLY_VIEWED_PRODUCTS_KEY, 'true'); // The value doesn't matter as long as it's a truthy string
        }

        setHasMounted(true);
    }, []);

    return { addRecentlyViewedProduct, isProductRecentlyViewed };
};
